import { render } from "./HelpButton.vue?vue&type=template&id=1a424a10&scoped=true&ts=true"
import script from "./HelpButton.vue?vue&type=script&lang=ts"
export * from "./HelpButton.vue?vue&type=script&lang=ts"

import "./HelpButton.vue?vue&type=style&index=0&id=1a424a10&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a424a10"]])

export default __exports__